import {format} from 'date-fns';

export const formatDate = (value: string) =>{
    return format(new Date(value), 'HH:mm dd/MM/yyyy');
};

export const formatDateOnlyDay = (value: string) =>{
    return format(new Date(value), 'dd/MM/yyyy');
};
